import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=6f981637&scoped=true"
import script from "./Reasons.vue?vue&type=script&lang=js"
export * from "./Reasons.vue?vue&type=script&lang=js"
import style0 from "./Reasons.vue?vue&type=style&index=0&id=6f981637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f981637",
  null
  
)

export default component.exports